import {MDIcon, MDIconSize} from '@mintdata-wsp/common/components/icon/MDIcon';
import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';
import {IDesignInfo} from '@mintdata-wsp/common/state/DataState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {Column} from '@mintdata-wsp/wsp/ui/components/forms/Column';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {WSPNewDesignButton} from '@mintdata-wsp/wsp/ui/components/general/WSPNewDesignButton';
import {BasePage} from '@mintdata-wsp/wsp/ui/pages/BasePage';
import {paths} from '@mintdata-wsp/wsp/ui/routes/Routing';
import {DesignsList} from '@mintdata-wsp/wsp/ui/views/workspace/home/designs/DesignsList';
import {
    DesignsFilter,
    DesignsFilters,
    DesignsFilterType
} from '@mintdata-wsp/wsp/ui/views/workspace/home/filters/DesignsFilters';
import * as classnames from 'classnames/bind';
import {computed} from 'mobx';
import {observer} from 'mobx-react';
import * as React from 'react';
import {RouteComponentProps} from 'react-router';
import {Link} from 'react-router-dom';

const styles = require('./HomePage.less');
const cx = classnames.bind(styles);

@observer
export class HomePage extends BasePage<RouteComponentProps<any>, any>
{
    @computed
    private get _filteredAllDesigns():Array<IDesignInfo>
    {
        const {allDesigns, getFilteredDesigns} = controllers.ui.mainPage;

        return getFilteredDesigns(allDesigns, DesignsFilterType.Designs, DesignsFilter.Recent);
    }

    @computed
    private get _filteredPublishedDesigns():Array<IDesignInfo>
    {
        const {allPublishedDesigns, getFilteredDesigns} = controllers.ui.mainPage;

        return getFilteredDesigns(allPublishedDesigns, DesignsFilterType.Applications, DesignsFilter.Recent);
    }

    private _renderViewLink = (isViewDesigns:boolean) =>
    {
        const {allDesigns, allPublishedDesigns} = controllers.ui.mainPage;

        let filteredLength;
        let length;
        let title;
        let url;

        if( isViewDesigns )
        {
            filteredLength = this._filteredAllDesigns.length;
            length = allDesigns.length;
            title = 'design';
            url = paths.designs();
        }
        else
        {
            filteredLength = this._filteredPublishedDesigns.length;
            length = allPublishedDesigns.length;
            title = 'application';
            url = paths.applications();
        }

        return (
            <Row className={styles.groupAllWrapper}>
                {
                    filteredLength > 0 &&
                    <Link
                        to={url}
                        className={styles.groupAllLink}
                    >
                        View {length} {title}{length !== 1 ? 's' : ''}
                        <MDIcon
                            name={MDIcons.common.ArrowForward}
                            className={styles.iconAllLink}
                            size={MDIconSize.medium20}
                        />
                    </Link>
                }
            </Row>
        );
    };

    render()
    {
        const {match} = this.props;

        const designsFilter = controllers.ui.mainPage.getDesignsFilter(DesignsFilterType.HomeDesignsMobile);

        const filterType:DesignsFilterType = designsFilter === DesignsFilter.All
            ? DesignsFilterType.HomeDesignsMobile
            : DesignsFilterType.HomeApplicationsMobile;

        const viewDesigns:boolean = filterType === DesignsFilterType.HomeDesignsMobile;

        return (
            <Column className={cx(styles.page)}>
                <Column className={cx(styles.scroll)}>

                    {/* TODO: ======================================= */}

                    <DesignsFilters
                        filterType={filterType}
                        className={styles.isMobileFilters}
                    />

                    {/* TODO: ======================================= */}

                    <Column className={cx(styles.mobile, {isShowMobile: viewDesigns})}>
                        <div className={styles.groupTitle}>
                            <span className={cx('designsTitle')}>Designs</span>
                            <WSPNewDesignButton className={styles.newDesign} />
                        </div>
                        <div className={styles.groupDesignsLine}>
                            <DesignsList
                                filterType={DesignsFilterType.HomeDesigns}
                                designs={this._filteredAllDesigns.slice(0, 10)}
                                newDesign={true}
                            />
                        </div>

                        {this._renderViewLink(true)}

                    </Column>

                    {/* TODO: ======================================= */}

                    <Column className={cx(styles.mobile, {isShowMobile: !viewDesigns})}>

                        <div className={styles.groupTitle}>
                            Applications
                        </div>

                        <div className={styles.groupDesignsLine}>
                            <DesignsList
                                filterType={DesignsFilterType.HomeApplications}
                                designs={this._filteredPublishedDesigns}
                                // newDesign={true}
                                viewAsApplication={true}
                            />
                        </div>

                        {this._renderViewLink(false)}

                    </Column>
                    {/* TODO: ======================================= */}

                </Column>
            </Column>
        );
    }
}
